export const nlwTiers = [
    'Merciless',
    'Excruciating',
    'Inexorable',
    'Catastrophic',
    'Terrifying',
    'Relentless',
    'Remorseless',
    'Extreme',
    'Insane',
    'Very Hard',
    'Hard',
    'Medium',
    'Easy',
    'Beginner',
    'Fuck',
] as const;

export type NlwTier = (typeof nlwTiers)[number];

export const nlwTierColorClasses: Record<
    NlwTier,
    { header: string; border: string; borderHover: string }
> = {
    Beginner: {
        header: 'text-blue-500',
        border: 'border-blue-500',
        borderHover: 'hover:border-blue-400',
    },
    Easy: {
        header: 'text-teal-300',
        border: 'border-teal-300',
        borderHover: 'hover:border-teal-200',
    },
    Medium: {
        header: 'text-lime-400',
        border: 'border-lime-400',
        borderHover: 'hover:border-lime-300',
    },
    Hard: {
        header: 'text-yellow-300',
        border: 'border-yellow-300',
        borderHover: 'hover:border-yellow-200',
    },
    'Very Hard': {
        header: 'text-amber-500',
        border: 'border-amber-500',
        borderHover: 'hover:border-amber-400',
    },
    Insane: {
        header: 'text-red-600',
        border: 'border-red-600',
        borderHover: 'hover:border-red-500',
    },
    Extreme: {
        header: 'text-fuchsia-500',
        border: 'border-fuchsia-500',
        borderHover: 'hover:border-fuchsia-400',
    },
    Remorseless: {
        header: 'text-purple-600',
        border: 'border-purple-600',
        borderHover: 'hover:border-purple-500',
    },
    Relentless: {
        header: 'text-violet-400',
        border: 'border-violet-400',
        borderHover: 'hover:border-violet-300',
    },
    Terrifying: {
        header: 'text-fuchsia-300',
        border: 'border-fuchsia-300',
        borderHover: 'hover:border-fuchsia-200',
    },
    Catastrophic: {
        header: 'text-red-400',
        border: 'border-red-400',
        borderHover: 'hover:border-red-300',
    },
    Inexorable: {
        header: 'text-orange-300',
        border: 'border-orange-300',
        borderHover: 'hover:border-orange-200',
    },
    Excruciating: {
        header: 'text-amber-200',
        border: 'border-amber-200',
        borderHover: 'hover:border-amber-100',
    },
    Merciless: {
        header: 'text-lime-300',
        border: 'border-lime-300',
        borderHover: 'hover:border-lime-200',
    },
    Fuck: {
        header: 'text-red-500',
        border: 'border-red-500',
        borderHover: 'hover:border-red-400',
    },
};
